import styled from '~/ui/styled'

const PreviewText = styled.Text<{ color?: string }>`
  font-size: 13px;
  min-width: max-content;
  color: ${({ color, theme }) => color || theme.colors.secondary};
`

export default PreviewText
